<template>
    <div class="detailUsersAdmin">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>

        <div v-else class="col-md-12">
            <v-form ref="form" lazy-validation class="col-sm-12 col-md-12">
                <div class="custom-row">
                    <div class="col-sm-12 col-md-5">

                        <v-text-field color=secondary label="*Primer Nombre" placeholder="Ingrese el primer nombre"
                            required :counter="50" :maxlength="50" :rules="firstNameRules"
                            v-model="formData.firstName"></v-text-field>

                        <v-text-field color=secondary label="*Primer Apellido" placeholder="Ingrese el primer apellido"
                            required :counter="50" :maxlength="50" :rules="lastNameRules"
                            v-model="formData.lastName"></v-text-field>

                        <v-select color="secondary" label="*Tipo Identificación"
                            placeholder="Selecciona un tipo de identificación" required :items="typeIdentification"
                            item-text="identificationType" item-value="identificationId"
                            :rules="tipoIdentificacionRules" v-model="formData.identificationId"></v-select>


                        <v-text-field color=secondary label="*Correo" placeholder="Ingrese un Correo" required
                            :counter="200" :maxlength="200" :rules="emailRules"
                            v-model="formData.emailAddress"></v-text-field>

                        <v-select color="secondary" label="*Género" placeholder="Selecciona un tipo de género" required
                            :items="affiliatedGender" item-text="gernderName" item-value="genderId" :rules="genderRules"
                            v-model="formData.genderId"></v-select>


                    </div>
                    <div class="col-sm-12 col-md-5">

                        <v-text-field color=secondary label="Segundo Nombre" placeholder="Ingrese el segundo nombre"
                            :counter="50" :maxlength="50" :rules="middleNameRules"
                            v-model="formData.middleName"></v-text-field>

                        <v-text-field color=secondary label="Segundo Apellido" placeholder="Ingrese el segundo apellido"
                            :counter="50" :maxlength="50" :rules="secondLastNameRules"
                            v-model="formData.secondLastName"></v-text-field>

                        <v-text-field color="secondary" label="*Número Identificación"
                            placeholder="Ingrese el Número Identificación" required
                            :rules="[...idNumberRules, idNumberLengthRule]" @input="formatIdentificationNumber"
                            v-model="formData.identificationNumber" @keydown="handleKeyDown" inputmode="numeric"
                            pattern="[0-9]{19}" :counter="19" :maxlength="19"></v-text-field>

                        <v-select color="secondary" label="*Rol" placeholder="Selecciona un tipo del rol" required
                            :items="updatedTypeRol" item-text="nameRole" item-value="roleId"
                            :disabled="!disableUserT || (formData.roleId == 1 && !isSuperAdmin)" :rules="tipoRolRules"
                            v-model="formData.roleId"></v-select>

                        <v-row>
                            <v-col cols="4" md="3" sm="3">
                                <v-select color="secondary" label="*Indicativo" required :items="listGender"
                                    item-text="countryPhoneCode" item-value="countryPhoneCodeId"
                                    v-model="formData.countryPhoneCodeId" :rules="CountryPhoneCodeRules">
                                </v-select>
                            </v-col>

                            <v-col cols="8" md="9" sm="9">
                                <v-text-field color="secondary" label="*Contacto WhatsApp"
                                    placeholder="Ingrese el Contacto WhatsApp" required
                                    :rules="[...idNumberCRules, idNumberCLengthRule]" v-model="formData.cellPhoneNumber"
                                    @keydown="handleKeyDown" inputmode="numeric" pattern="[0-9]{10}" :counter="10"
                                    :maxlength="10">
                                </v-text-field>
                            </v-col>
                        </v-row>

                    </div>
                </div>
            </v-form>

        </div>

        <v-tooltip left>

            <template v-slot:activator="{ on, attrs }">

                <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on" @click="submitForm">
                    <v-icon dark>mdi-content-save</v-icon>
                </v-btn>

            </template>

            <span>Actualizar usuario</span>

        </v-tooltip>
    </div>
</template>



<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";

import {
    USERSADMIN_M,
    ACTION_PUT_UPDATE_USERSADMIN,
    ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT,
    GET_USERADMIN_LIST_TYPE_DOCUMENT,
    ACTION_GET_USERSADMIN_LIST_TYPE_ROL,
    GET_USERADMIN_LIST_TYPE_ROL,
    ACTION_GET_USERSADMIN_ID,
    GET_USER_ADMIN_ID,
    GET_STATE_LOADING,
    ACTION_GET_AFFILIATEDUSERS_LIST_GENDER,
    GET_AFFILIATEDUSERS_LIST_GENDER,
} from "@/views/users_admin/store/types/types.js";

import {
    PRODUCTS_M,
    ACTION_GET_LIST_COUNTRY,
    GET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";

import Swal from "sweetalert2";

const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {

    },
    name: "detailUsersAdmin",
    props: {
        usersAdmin: {
            required: true
        },
        disableUserT: {
            required: true
        }
    },

    data() {
        return {
            formData: {
                userId: '',
                firstName: '',
                middleName: '',
                lastName: '',
                isFirstUserCompany: false,
                companyId: '',
                secondLastName: '',
                identificationType: '',
                emailAddress: '',
                genderId: '',
                gernderName: '',
                identificationId: '',
                cellPhoneNumber: '',
                roleId: '',
                nameRole: '',
                identificationNumber: '',
                countryPhoneCodeId: '',
                userDetailId: '',
            },

            roleId: sessionStorage.getItem("roleId"),
            firstNameRules: [
                v => !!v || "Primer Nombre requerido",
                v => (v && v.length <= 50) || "El primer nombre no puede tener más de 50 caracteres"
            ],
            middleNameRules: [
                v => (v != null && v.length <= 50) || "El segundo nombre no puede tener más de 50 caracteres"
            ],
            lastNameRules: [
                v => !!v || "El primer apellido requerido",
                v => (v && v.length <= 50) || "El primer apellido no puede tener más de 50 caracteres"
            ],

            secondLastNameRules: [
                v => (v != null && v.length <= 50) || "El segundo apellido no puede tener más de 50 caracteres"
            ],

            tipoIdentificacionRules: [
                v => !!v || "Tipo identificación requerido"
            ],

            idNumberRules: [
                v => !!v || "El número identificación requerido",
            ],
            idNumberLengthRule: v =>
                (v && v.length <= 19) || "El número de identificación debe tener 19 dígitos",


            emailRules: [
                v => !!v || "El correo requerido",
                v => (v && v.length <= 200) || "El correo no puede tener más de 200 caracteres",
                v => correoRegex.test(v) || "El formato del correo es inválido"
            ],

            tipoRolRules: [
                v => !!v || "Rol requerido"
            ],

            genderRules: [
                v => !!v || "El género requerido"
            ],

            idNumberCRules: [
                v => !!v || "El contacto WhatsApp es requerido",
            ],

            idNumberCLengthRule: v =>
                (v.length === 10) || "El contacto WhatsApp debe tener 10 dígitos",

            CountryPhoneCodeRules: [
                v => !!v || "El indicativo es requerido"
            ],

            showErrorMessages: false,
            usersAdminUpdate: null,
        };
    },

    async mounted() {
    try {
        this.loading = true;
        if (this.usersAdmin) {
            this.usersAdminsUpdate = await this.getActionUsersAdminId(this.usersAdmin);
            this.updateUserAdmin();
        }
        await Promise.all([
            this.getActionTypeIdentification(),
            this.getActionTypeRol(),
            this.getActionListCountry(),
            this.getAffiliatedGender()
        ]);
    } catch (error) {
        console.error("Error en mounted:", error);
    } finally {
        this.loading = false;
    }
},

    computed: {
        ...mapGetters({
            loading: [`${USERSADMIN_M}${GET_STATE_LOADING}`],
            typeIdentification: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_DOCUMENT}`],
            typeRol: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_ROL}`],
            affiliatedGender: [`${USERSADMIN_M}${GET_AFFILIATEDUSERS_LIST_GENDER}`],
            listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],
            userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_ID}`],

        }),

        isSuperAdmin() {
            return this.roleId === "1";
        },

        updatedTypeRol() {
            const roles = [...this.typeRol];
            // Verificar si el rolId actual está en la lista de roles
            if (this.formData.roleId && !roles.find(role => role.roleId === this.formData.roleId)) {
                // Agregar el rol correspondiente si no está en la lista
                roles.push({
                    nameRole: this.formData.nameRole,
                    roleId: this.formData.roleId
                });
            }
            return roles;
        },


    },

    watch: {
        usersAdmin: {
            immediate: true,
            handler(newVal) {
                // Actualizar `formData.roleId` según sea necesario
                this.formData.roleId = newVal.roleId || null;
            }
        }
    },

    methods: {

        ...mapActions({
            putActionActualizarUsersAdmin: `${USERSADMIN_M}${ACTION_PUT_UPDATE_USERSADMIN}`,
            getActionTypeIdentification: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT}`,
            getActionTypeRol: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_ROL}`,
            getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,
            getAffiliatedGender: `${USERSADMIN_M}${ACTION_GET_AFFILIATEDUSERS_LIST_GENDER}`,
            getActionUsersAdminId: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_ID}`,
        }),


        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },
        async updateUserAdmin() {
            this.formData.userId = this.usersAdmin,
                this.formData.firstName = this.usersAdminsUpdate.firstName,
                this.formData.middleName = this.usersAdminsUpdate.middleName,
                this.formData.lastName = this.usersAdminsUpdate.lastName,
                this.formData.isFirstUserCompany = false,
                this.formData.companyId = sessionStorage.getItem("idEmpresa"),
                this.formData.secondLastName = this.usersAdminsUpdate.secondLastName,
                this.formData.identificationType = this.usersAdminsUpdate.identification.identificationType,
                this.formData.emailAddress = this.usersAdminsUpdate.emailAddress,
                this.formData.genderId = this.usersAdminsUpdate.userDetailResponse.gender.genderId,
                this.formData.gernderName = this.usersAdminsUpdate.gernderName,
                this.formData.identificationId = this.usersAdminsUpdate.identification.identificationId,
                this.formData.cellPhoneNumber = this.usersAdminsUpdate?.userDetailResponse?.cellPhoneNumber,
                this.formData.roleId = this.usersAdminsUpdate.role.roleId,
                this.formData.nameRole = this.usersAdminsUpdate.role.nameRole,
                this.formData.identificationNumber = this.usersAdminsUpdate.identificationNumber,
                this.formData.countryPhoneCodeId = this.usersAdminsUpdate?.userDetailResponse.countryPhoneCode?.countryPhoneCodeId || null,
                this.formData.userDetailId = this.usersAdminsUpdate.userDetailResponse?.userDetailId

        },
        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }

                    const update = await this.putActionActualizarUsersAdmin(this.formData);
                    EventBus.$emit('reload-update-usersAdmin', update.nombre);

                    if (!update) {
                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        });
                    }
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error("Fallo al actualizar", error);
            }
        },

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },

        validateForm() {
            this.showErrorMessages = true;

            const errors = {};

            if (!this.formData.firstName || !this.formData.firstName.trim() || this.formData.firstName.length > 50) {
                errors.firstName = 'Primer Nombre';
            }

            if (this.formData.middleName && !/\S(?:.*\S)?/.test(this.formData.middleName)) {
                errors.middleName = 'Segundo Nombre no debe contener espacios en blanco';
            }

            if (!this.formData.lastName || !this.formData.lastName.trim() || this.formData.lastName.length > 50) {
                errors.lastName = 'Primer Apellido';
            }

            if (this.formData.secondLastName && !/\S(?:.*\S)?/.test(this.formData.secondLastName)) {
                errors.secondLastName = 'Segundo Apellido no debe contener espacios en blanco';
            }

            if (!this.formData.identificationType) {
                errors.identificationType = 'Tipo Identificación';
            }

            if (!this.formData.emailAddress || !correoRegex.test(this.formData.emailAddress) || this.formData.emailAddress.length > 200) {
                errors.emailAddress = 'Correo';
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = 'Número Identificación';
            }

            if (!this.formData.genderId) {
                errors.genderId = 'Género';
            }

            if (!this.formData.nameRole) {
                errors.nameRole = 'Rol';
            }

            if (!this.formData.countryPhoneCodeId) {
                errors.countryPhoneCodeId = 'Indicativo es requerido';
            }

            if (!this.formData.cellPhoneNumber || !this.formData.cellPhoneNumber.trim() || this.formData.cellPhoneNumber.length !== 10) {
                errors.cellPhoneNumber = 'Contacto WhatsApp';
            }

            return errors;
        },
    },


};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

.detailUsersAdmin {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-row {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-col {
    padding-left: 5px;
    padding-right: 5px;
}

/*Resposive*/
@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .custom-row {
        display: flex;
        gap: 20px;
        flex-direction: column;
        justify-content: center;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }

    .custom-row {
        display: flex;
        gap: 50px;
        flex-direction: column;
        justify-content: center;
    }
}
</style>